<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>{{ $tc('general.n0') }}</th>
          <th>{{ $tc('club.club_name') }}</th>
          <th>Cena bez popusta</th>
          <th>Cena sa popustom</th>
          <th>Popust udruženja</th>
          <th style="text-align: right;">Ukupno</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="item.club.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ item.club.name }}</td>
          <td>{{ item.priceWithoutDiscount || 0 }} RSD</td>
          <td>{{ item.priceWithDiscount || 0 }} RSD</td>
          <td>{{ getCostReduction(item.club) }}% ({{ (item.priceWithoutDiscount || 0) - (item.total || 0) }} RSD)</td>
          <td style="text-align: right;">{{ item.total || 0 }} RSD</td>
        </tr>
      </tbody>
    </table>

    <div style="text-align: right; line-height: 1.5; margin-top: 15px;">Cena bez popusta: <b>{{ priceOne }} RSD</b></div>
    <div style="text-align: right; line-height: 1.5;">Cena sa popustom: <b>{{ priceTwo }} RSD</b></div>
    <div style="text-align: right; line-height: 1.5;">Ukupno: <b>{{ total }} RSD</b></div>
  </div>
</template>

<script>
export default {
  props: {
    seminar: { type: Object, required: true },
    participants: { type: Array, default: () => [] }
  },

  computed: {
    unitPrice () {
      return this.seminar?.single_fee_1 ?? 0
    },
    unitDiscount () {
      return this.seminar?.single_fee_1_break ?? 0
    },
    unitNet () {
      return this.unitPrice - this.unitDiscount
    },

    clubs () {
      const byClub = {}
      this.participants.forEach(p => {
        const club = p.club
        if (!club) return
        const id = club.id
        if (!byClub[id]) byClub[id] = { club, participants: [] }
        byClub[id].participants.push(p)
      })
      return Object.values(byClub)
    },

    data () {
      return this.clubs.map(({ club, participants: list }) => {
        const priceWithoutDiscount = list.length * this.unitPrice
        const priceWithDiscount = list.length * this.unitNet
        const deduction = this.getCostReduction(club)
        const total = deduction ? Math.round((priceWithDiscount * (100 - deduction)) / 100) : priceWithDiscount
        return { club, priceWithoutDiscount, priceWithDiscount, total }
      })
    },

    priceOne () {
      return this.data.reduce((acc, item) => acc + item.priceWithoutDiscount, 0)
    },
    priceTwo () {
      return this.data.reduce((acc, item) => acc + item.priceWithDiscount, 0)
    },
    total () {
      return this.data.reduce((acc, item) => acc + (item.total || 0), 0)
    }
  },

  methods: {
    getCostReduction (club) {
      const list = this.seminar?.clubDeductions || []
      const d = list.find(x => parseInt(x.clubId) === parseInt(club.id))
      return d ? d.deduction : 0
    }
  }
}
</script>
